import styled from 'styled-components/macro';
import {useToast} from "@chakra-ui/react";
import CommunityLogo from './community_logo';
import Button from './button';
import {Star} from "lucide-react";

const Subscribe = styled(Button)``;
const Info = styled.div``;

const Community = styled(({className, community, onClick, onSubscribe}) => {
    const {name} = community || '';
    const toast = useToast();
    const handleSubscribe = async () => {
        try {
            await onSubscribe([community.name]);
        } catch {
            toast({
                title: 'Something went wrong.',
                status: 'error',
                isClosable: true,
            })
        }
    }
    return (
        <div className={className} onClick={onClick}>
            <Info>
                <CommunityLogo name={name} />
                {name}
            </Info>
            {<Subscribe onClick={handleSubscribe}>
                {community?.is_subscribed
                    ? <Star size={18} fill={"#ffbe00"} style={{color: '#ffbe00'}} />
                    : <Star size={18} style={{color: '#70767b'}} />}
            </Subscribe>}
        </div>
    );
})`
  font-size: 15px;
  display: flex;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;

  img {
    margin-right: 12px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  ${Info} {
    display: flex;
    align-items: center;
  }

  ${Subscribe} {
    margin-left: auto;
    border-radius: 4px;
    background-color: inherit;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 700;
  }
`;

export default Community;
